export default "__VITE_ASSET__DiOS0C9u__"